import { render, staticRenderFns } from "./ServerBundles.vue?vue&type=template&id=3f0cefd5"
import script from "./ServerBundles.vue?vue&type=script&lang=js"
export * from "./ServerBundles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports